import { SVGProps } from 'react';
const SvgIconLinkedinCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 100 100" {...props}>
    <g transform="translate(-167 -3583)">
      <rect width={100} height={100} transform="translate(167 3583)" fill="#fff" opacity={0} />
      <g transform="translate(161.642 3575.369)">
        <path
          d="M55.358,97.63a39.954,39.954,0,1,1,10.717-1.451"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.984}
        />
        <g transform="translate(33.804 36.232)">
          <path
            d="M79.139,66.3A10.19,10.19,0,0,1,84.3,65.043c6.373,0,11.152,4.164,11.152,13.112v16.7H85.77V79.274c0-3.915-1.4-6.587-4.906-6.587A5.3,5.3,0,0,0,75.9,76.229a6.628,6.628,0,0,0-.322,2.361V94.859H65.887s.131-26.4,0-29.132h9.687v2.881"
            transform="translate(-50.272 -51.685)"
            fill="none"
            stroke="#0084f5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.984}
          />
          <path
            d="M80.827,72.989"
            transform="translate(-55.141 -54.274)"
            fill="none"
            stroke="#0084f5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.984}
          />
          <path
            d="M48.075,55.294h.065c3.378,0,5.48-2.239,5.48-5.036A5.032,5.032,0,0,0,48.2,45.226c-3.314,0-5.482,2.173-5.482,5.032a5.153,5.153,0,0,0,.38,1.966"
            transform="translate(-42.722 -45.226)"
            fill="none"
            stroke="#0084f5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.984}
          />
          <path
            d="M43.576,66.058V95.19h9.684V66.058"
            transform="translate(-43 -52.016)"
            fill="none"
            stroke="#0084f5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.984}
          />
        </g>
      </g>
    </g>
  </svg>
);
export default SvgIconLinkedinCircle;
